import { Upload } from "@portal/BaseComponents/Upload/AntUpload";
import { Files } from "@portal/types/file";
import styled from "styled-components";


export const StyledDocUpload = styled(Upload<Files>)`
  .ant-upload-list {
    margin-top: var(--space-16);
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-8);
    justify-content: flex-start;

    &::before {
      content: none;
    }

    .ant-upload-list-item-container {
      height: 40px;
    }
  }
`;
